// Real contact details provided by the owner.
export const CONTACT = {
  name: "Sobe Bevanda",
  place: "Međugorje",
  address: "Ivana Pavla II 7C, 88266 Međugorje, Bosna i Hercegovina",
  phoneDisplay: "+387 63 177 732",
  phoneHref: "tel:+38763177732",
  whatsapp: "38763177732",
  email: "sobe.bevanda@outlook.com",
  directionsUrl: "https://maps.app.goo.gl/VDvknAyicEEsNKmd7",
  mapEmbed:
    "https://www.google.com/maps?q=Sobe%20Bevanda%2C%20Me%C4%91ugorje%2C%20Bosna%20i%20Hercegovina&output=embed",
};

const OLD = "https://www.bevanda-medjugorje.com/wp-content/uploads/2013/08";

export const IMG = {
  hero: "/images/hero.jpg",
  house: "/images/hero.jpg",
  roomA: "/images/room-old-1.jpg",
  roomB: "/images/room-old-2.jpg",
  roomC: "/images/room-old-3.jpg",
  roomStock:
    "https://images.pexels.com/photos/14547138/pexels-photo-14547138.jpeg?auto=compress&cs=tinysrgb&w=1400",
  diningA: "/images/dining-1.jpg",
  diningB: "/images/dining-2.jpg",
  diningC: "/images/dining-3.jpg",
  breakfast: "/images/blagovaonica.jpg",
  church: "/images/st-james-church.jpg",
  bellTower:
    "https://images.pexels.com/photos/29114083/pexels-photo-29114083.jpeg?auto=compress&cs=tinysrgb&w=1400",
  terrace:
    "https://images.pexels.com/photos/38431030/pexels-photo-38431030.jpeg?auto=compress&cs=tinysrgb&w=1400",
  twin:
    "https://images.pexels.com/photos/38183819/pexels-photo-38183819.jpeg?auto=compress&cs=tinysrgb&w=1400",
  family:
    "https://images.pexels.com/photos/8134775/pexels-photo-8134775.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const ROOM_IMAGES = {
  single: "/images/room-single.jpg",
  double: "/images/room-double.jpg",
  triple: "/images/room-triple.jpg",
  quadruple: "/images/room-quadruple.jpg",
};

export const GALLERY = [
  { src: IMG.roomA, cat: "rooms", alt: "Sobe Bevanda — guest room" },
  { src: IMG.roomB, cat: "rooms", alt: "Sobe Bevanda — guest room interior" },
  { src: IMG.roomC, cat: "rooms", alt: "Sobe Bevanda — bedroom" },
  { src: "/images/room-single.jpg", cat: "rooms", alt: "Single room at Sobe Bevanda" },
  { src: "/images/room-double.jpg", cat: "rooms", alt: "Double room at Sobe Bevanda" },
  { src: "/images/room-triple.jpg", cat: "rooms", alt: "Triple room at Sobe Bevanda" },
  { src: "/images/room-quadruple.jpg", cat: "rooms", alt: "Quadruple room at Sobe Bevanda" },
  { src: IMG.house, cat: "property", alt: "Sobe Bevanda — family house" },
  { src: IMG.diningA, cat: "dining", alt: "Dining room at Sobe Bevanda" },
  { src: IMG.diningB, cat: "dining", alt: "Dining room interior" },
  { src: IMG.diningC, cat: "dining", alt: "Dining room table setting" },
  { src: IMG.breakfast, cat: "dining", alt: "Dining room at Sobe Bevanda" },
  { src: IMG.church, cat: "medjugorje", alt: "St. James Church in Međugorje" },
  { src: "/images/podbrdo.jpg", cat: "medjugorje", alt: "Our Lady statue on Apparition Hill, Podbrdo" },
  { src: "/images/krizevac.jpg", cat: "medjugorje", alt: "The cross on Cross Mountain, Križevac" },
];
